// extracted by mini-css-extract-plugin
export default {"Checkbox":"Checkbox_Checkbox__ZbQIo","indeterminate":"Checkbox_indeterminate__K6Nid","swing-in":"Checkbox_swing-in__6gReQ"};